/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { AssignOrChangeUserLocationProps } from '../DeleteUserLocation';

type InjectedProps = {|
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

type DeleteUserLocationSuccessProps = {
  ...AssignOrChangeUserLocationProps,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class DeleteUserLocationSuccess extends ComponentWithInjectedProps<
  DeleteUserLocationSuccessProps,
  {},
  InjectedProps
> {
  render() {
    const { t, actionDrawerStore } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:users.location_removed')}</h3>
            <p>{t('general:users.messages.location_removed')}</p>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
